import { Component } from '@angular/core';
import { TRUST_STATS } from '../../data/landing-content';

@Component({
  selector: 'landing-inversores-trust-stats',
  templateUrl: './landing-trust-stats.component.html',
  styleUrls: ['./landing-trust-stats.component.scss'],
})
export class LandingTrustStatsComponent {
  readonly stats = TRUST_STATS;
}
